import { donutChartActions } from "./donutChart-slice";
import { uiActions } from "./ui-slice";
import axios from 'axios'
// import '../utils/axios-interceptor'

export const fetchGraphData = (url_data, token) => {
	return async (dispatch) => {
		dispatch(uiActions.showLoadingSpinner(5));

		const fetchData = async () => {
			const response = await axios.get(url_data, {token: token});

			if (response.status !== 200) {
				throw new Error("Fetching data failed.");
			}

			const data = await response.data;

			return data;
		};

		try {
			const graphData = await fetchData();
			dispatch(donutChartActions.updateGraph(graphData));
			dispatch(uiActions.hideLoadingSpinner(5));
		} catch (error) {
			console.log(error);
		}
	};
};
